import React from "react";
import { Link } from "react-router-dom";
import { PageShell } from "../components/PageShell";

export default function LandingPage() {
  return (
    <PageShell>
      <div className="text-center" data-testid="landing-page">
        <h1 className="text-3xl font-bold tracking-tight sm:text-4xl">Fulkra Works</h1>
        <p className="mt-4 text-base text-slate-700">
          Toegang tot dit programma loopt via uw werkgever.<br />
          Heeft u een aanmeldlink ontvangen? Open die link op uw telefoon of computer.
        </p>
        <div className="mt-8 rounded-lg border border-slate-200 bg-white p-5 text-left text-sm text-slate-700">
          <p className="font-medium text-slate-900">Geen aanmeldlink ontvangen?</p>
          <p className="mt-2">
            Neem contact op met uw werkgever, of mail naar{" "}
            <a className="text-blue-700 underline" href="mailto:info@fulkraworks.nl">info@fulkraworks.nl</a>.
          </p>
        </div>
        <p className="mt-6 text-xs text-slate-500">
          <Link to="/wen-instructies" className="underline" data-testid="link-wen-instructies">Inloopinstructies voor uw nieuwe steunzolen</Link>
        </p>
      </div>
    </PageShell>
  );
}
